var StorageKeys = /** @class */ (function () {
    function StorageKeys() {
    }
    StorageKeys.CODE = 'COURSE_CODE';
    StorageKeys.COURSE_ID = 'COURSE_ID';
    StorageKeys.SELECTED_COURSE_TIME_SCHEDULE_ID = 'SELECTED_COURSE_TIME_SCHEDULE_ID';
    StorageKeys.LAST_BOOKING_STEP = 'LAST_BOOKING_STEP';
    StorageKeys.PERSON_IDENTIFICATION_VALIDATION = 'PERSON_IDENTIFICATION_VALIDATION';
    StorageKeys.INTAKE_REGISTRATION_SELF_ASSESSMENT = 'INTAKE_REGISTRATION_SELF_ASSESSMENT';
    StorageKeys.SHOPPING_CART_MODEL = 'SHOPPING_CART_MODEL';
    // onsite lector (DUO Weltweit vor Ort)
    StorageKeys.LECTOR_USERNAME = 'LECTOR_USERNAME';
    StorageKeys.LECTOR_PASSWORD = 'LECTOR_PASSWORD';
    return StorageKeys;
}());
export { StorageKeys };
